type Props = {
  testId?: string;
};

const Section: FC<Props> = ({ children, testId = "page" }) => (
  <section data-testid={`${testId}-section`} className="flex flex-col gap-5">
    {children}
  </section>
);

export default Section;
